const nl = {
  ErGingIetsMis: "Something went wrong. Please try again later or contact customer support."
};

export default nl;
